import { Button, Col, Row, Table, TableColumnType, Tag, Tooltip, message as antdMessage } from 'antd';
import { FlexCol, FlexRow, Paper } from '../../components/common/common';
import { useEffect, useState } from 'react';
import { getAllModels, putModel } from '../../services/cache/idb';
import { Model } from '../../components/analysis/definitions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faDroplet, faFileCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { loadModel, saveModel } from '../../services/cache/localStorage';
import { useMediaQuery } from '../../utils/helpers/utils';
import { PlusOutlined } from '@ant-design/icons';
import TextArea from 'antd/es/input/TextArea';

type ModelsPageProps = {};

export const ModelsTable: React.FC<ModelsPageProps> = () => {
  const [models, setModels] = useState<Model[]>([]);
  const [currentModel, setCurrentModel] = useState<Model>();
  const [showAddModelArea, setShowAddModelArea] = useState<boolean>(false);
  const [modelText, setModelText] = useState<string>('');
  const isMobile = useMediaQuery();

  const validateAndSaveModel = async () => {
    try {
      let model: Model = JSON.parse(modelText);
      await putModel(model);

      let allModels = await getAllModels();
      setModels(allModels);

      antdMessage.success('succesfully saved model !');
      setModelText('');
    } catch (error) {
      antdMessage.error(`Fail to load model ${error}`);
    }
  };

  useEffect(() => {
    getAllModels().then((models) => {
      setModels(models);
    });
  }, []);

  useEffect(() => {
    let _model = loadModel();
    if (_model !== null) setCurrentModel(_model);
  }, []);

  let columns: TableColumnType<any>[] = [
    {
      title: 'Name',
      render: (model: Model) => {
        return model?.metadata.ID.charAt(0).toUpperCase() + model?.metadata.ID.slice(1);
      },
    },
    {
      title: 'Date/Time',
      render: (model: Model) => {
        return new Date(model?.metadata.created_at).toLocaleString();
      },
      sortDirections: ['descend', 'ascend'],
      sorter: (a: Model, b: Model) => {
        return new Date(a.metadata.created_at).getTime() - new Date(b.metadata.created_at).getTime();
      },
      defaultSortOrder: 'descend',
    },
    {
      title: 'Comparison threshold',
      dataIndex: 'comparisonThreshold',
    },
    {
      title: 'Spotfile',
      render: (model: Model) => {
        return model?.metadata.spotfile.map((s) => s + ', ');
      },
    },
    {
      title: 'Type',
      render: (model: Model) => {
        return <Tag>{model?.metadata.type}</Tag>;
      },
    },
    {
      title: 'Apply',
      fixed: 'right',
      render: (model: Model) => {
        return (
          <FlexRow style={{ width: '100%' }}>
            {currentModel && currentModel.metadata?.ID === model.metadata.ID ? (
              <Button type="primary" icon={<FontAwesomeIcon icon={faCheck} style={{ fontSize: '13pt' }} />} />
            ) : (
              <Button
                icon={<FontAwesomeIcon icon={faFileCircleCheck} style={{ fontSize: '13pt' }} />}
                onClick={async () => {
                  try {
                    if (model) {
                      saveModel(model);
                      setCurrentModel(model);
                    }
                  } catch (e: any) {
                    antdMessage.error(`Error while loading model: ${e.message}`);
                  }
                }}
              />
            )}
            {/* <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={async () => {
                deleteRecord(record.key);
                setRecords(await getAllRecords());
              }}
            >
              <Button type="text" danger icon={<DeleteOutlined />} />
            </Popconfirm> */}
          </FlexRow>
        );
      },
      width: 120,
    },
  ];

  if (isMobile) {
    columns = columns.filter((column) => {
      return column.title === 'Date/Time' || column.title === 'Name' || column.title === 'Apply';
    });
  }

  return (
    <FlexCol
      style={{
        width: '100%',
      }}
    >
      <Paper>
        <FlexCol
          style={{
            width: '100%',
          }}
        >
          <Table
            size="small"
            columns={columns}
            dataSource={models}
            rowKey={(record) => record.key}
            // rowSelection={{
            //   type: 'checkbox',
            //   selectedRowKeys: selectedRowKeys,
            //   onChange: (selectedRowKeys) => {
            //     setSelectedRowKeys(selectedRowKeys as RecordKey[]);
            //   },
            //   preserveSelectedRowKeys: false,
            // }}
            style={{
              width: '100%',
            }}
          />
          <Row justify="end" gutter={[10, 10]}>
            <Col>
              <Tooltip overlay={<>Add model</>}>
                <Button
                  icon={<PlusOutlined />}
                  onClick={async () => {
                    setShowAddModelArea(!showAddModelArea);
                  }}
                />
              </Tooltip>
            </Col>
          </Row>
        </FlexCol>
      </Paper>
      {showAddModelArea && (
        <Paper>
          <TextArea rows={4} value={modelText} onChange={(e) => setModelText(e.target.value)} maxLength={1000000} placeholder="paste your model here" />
          <Button onClick={validateAndSaveModel}>Submit</Button>
        </Paper>
      )}
    </FlexCol>
  );
};
